var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [_c("router-view"), _vm._v(" "), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "elevator", attrs: { id: "J_GotoTop" } }, [
      _c(
        "a",
        {
          staticClass: "elevator-msg",
          attrs: {
            href: "javascript:void(0)",
            onclick: "doyoo.util.openChat('g=10080393'); return false;"
          }
        },
        [
          _c("i", { staticClass: "iconfont icon-kefu" }),
          _vm._v(" "),
          _c("span", {}, [_vm._v("在线"), _c("br"), _vm._v("客服")])
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "elevator-top no-goto",
          staticStyle: { display: "none" },
          attrs: { id: "backTop", href: "javascript:void(0)" }
        },
        [
          _c("i", { staticClass: "iconfont icon-fanhuidingbu1" }),
          _vm._v(" "),
          _c("span", {}, [_vm._v("返回"), _c("br"), _vm._v("顶部")])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 